export const routerConfigToRouteKey = <
  P extends Record<string, any> = Record<string, any>
>(
  config: P
) =>
  Object.keys(config).reduce(
    (acc, routeKey) => ({ ...acc, [routeKey]: routeKey }),
    {} as Record<keyof P, string>
  );
